module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/cards/scrum-card/scrum-card.component.scss
// module id = ./src/app/shared/components/cards/scrum-card/scrum-card.component.scss
// module chunks = main